import { BusinessReportOutcomeEvidenceEvent } from "./types";
import { Highlight } from "@/types/evidences";

export const convertToEvidence = (msg: BusinessReportOutcomeEvidenceEvent) => ({
  highlights: msg.highlights ? (JSON.parse(msg.highlights) as Highlight[]) : [],
  citationId: String(msg.citation_id),
  documentId: msg.document_id,
  fseId: msg.fse_id,
  business_report_prompt_id: msg.business_report_prompt_id,
  id: `evidence-${msg.citation_id}`,
  answerOffsetEnd: msg.answer_offset_end || 0,
  answerOffsetStart: msg.answer_offset_start || 0,
});
